export const helpId = '556d1055-6aba-416b-bb84-403cb94f534e';

export const fontMap: Record<string, string> = {
  font_0: 'Heading 1',
  font_2: 'Heading 2',
  font_3: 'Heading 3',
  font_4: 'Heading 4',
  font_5: 'Heading 5',
  font_6: 'Heading 6',
  font_7: 'Paragraph 1',
  font_8: 'Paragraph 2',
  font_9: 'Paragraph 3',
};
